export default __webpack_public_path__ + "static/media/1613.78e3af46.png";